import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl, getThreeRandomWorkshopsUrl, getWorkshopsUrl } from "../../shared/constants/apiUrls";

const initialState = {
  workshops: [],
  loading: false,
  error: null,
  randomWorkshops: [],
  randomWorkshopsLoading: false,
  randomWorkshopsError: null,
  selectedWorkshopForMap: null,
  selectedWorkshop: null,
  selectedWorkshopLoading: false,
  selectedWorkshopError: null,
  defaultLocation: {
    lat: 60.1695,
    lng: 24.9354,
  },
};

const updateWorkshops = (state, action) => {
  let workshops = action.payload.workshops ? [...action.payload.workshops] || [] : action.payload;
  if (action.payload.orderBy != null) {

    // Changed place where this sorting is handled
    // // If order by distance, sort workshops by distance
    // if (action.payload.orderBy === "distance") {
    //   workshops.sort((a, b) => a.distance - b.distance);
    // }
    // // If order by rating, sort workshops by rating
    // if (action.payload.orderBy === "rating") {
    //   workshops.sort((a, b) => (b.ratings?.rating ?? 0) - (a.ratings?.rating ?? 0));
    // }
  }

  // Before set workshops, add new parameter orderNr to each workshop
  workshops = workshops.map((workshop, index) => ({
    ...workshop,
    orderNr: index + 1,
  }));
  state.workshops = workshops;
};

export const getWorkshops = createAsyncThunk("workshop/getWorkshops", async ({ location, filter }, { rejectWithValue }) => {
  try {
    const response = await axios.post(
      `${getWorkshopsUrl}/${location.lat}/${location.lng}`,
      JSON.stringify(filter), // or { filter } based on your API
    );
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const getThreeRandomWorkshops = createAsyncThunk("workshop/getThreeRandomWorkshops", async (_, { rejectWithValue }) => {
  try {
    const response = await axios.get(getThreeRandomWorkshopsUrl);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const getWorkshop = createAsyncThunk("workshop/getWorkshop", async (pathname, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${baseUrl}${pathname}`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

const workshopSlice = createSlice({
  name: "workshop",
  initialState,
  reducers: {
    setWorkshops: (state, action) => {
      updateWorkshops(state, action);
    },
    emptySelectedWorkshop: (state) => {
      state.workshops = [];
      state.selectedWorkshopForMap = null;
    },
    setWorkshopForMap: (state, action) => {
      state.selectedWorkshopForMap = action.payload;
    },
    emptyWorkshopForMap: (state) => {
      state.selectedWorkshopForMap = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWorkshops.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getWorkshops.fulfilled, (state, action) => {
        state.loading = false;
        updateWorkshops(state, action);
      })
      .addCase(getWorkshops.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(getThreeRandomWorkshops.pending, (state) => {
        state.randomWorkshopsLoading = true;
        state.randomWorkshopsError = null;
      })
      .addCase(getThreeRandomWorkshops.fulfilled, (state, action) => {
        state.randomWorkshopsLoading = false;
        state.randomWorkshops = action.payload || [];
      })
      .addCase(getThreeRandomWorkshops.rejected, (state, action) => {
        state.randomWorkshopsLoading = false;
        state.randomWorkshopsError = action.payload || action.error.message;
      })
      .addCase(getWorkshop.pending, (state) => {
        state.selectedWorkshopLoading = true;
        state.selectedWorkshopError = null;
      })
      .addCase(getWorkshop.fulfilled, (state, action) => {
        state.selectedWorkshopLoading = false;
        state.selectedWorkshop = action.payload || null;
      })
      .addCase(getWorkshop.rejected, (state, action) => {
        state.selectedWorkshopLoading = false;
        state.selectedWorkshopError = action.payload || action.error.message;
      });
  },
});

export const { setWorkshops, emptySelectedWorkshop, setWorkshopForMap, emptyWorkshopForMap } = workshopSlice.actions;

export const workshops = (state) => state.workshop.workshops;
export const workshopLoading = (state) => state.workshop.loading;
export const workshopError = (state) => state.workshop.error;

export const randomWorkshops = (state) => state.workshop.randomWorkshops;
export const randomWorkshopsLoading = (state) => state.workshop.randomWorkshopsLoading;
export const randomWorkshopsError = (state) => state.workshop.randomWorkshopsError;

export const workshopForMap = (state) => state.workshop.selectedWorkshopForMap;

export const selectedWorkshop = (state) => state.workshop.selectedWorkshop;
export const selectedWorkshopLoading = (state) => state.workshop.selectedWorkshopLoading;
export const selectedWorkshopError = (state) => state.workshop.selectedWorkshopError;

export const defaultLocation = (state) => state.workshop.defaultLocation;

export default workshopSlice.reducer;
